
import { 
  doc, 
  getDoc, 
  serverTimestamp,
  setDoc
} from "firebase/firestore";
import { db } from "./config";

// Generate 8-character invitation code
const generateInvitationCode = (): string => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let result = '';
  for (let i = 0; i < 8; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

// Updated createInvitation to use 8-character invitation code
export const createInvitation = async (email: string, tempUserId: string) => {
  try {
    console.log("Starting createInvitation for email:", email, "tempUserId:", tempUserId);
    
    // Generate a unique 8-character invitation code
    let invitationCode: string;
    let attempts = 0;
    const maxAttempts = 10;
    
    do {
      invitationCode = generateInvitationCode();
      attempts++;
      
      console.log("Generated invitation code attempt", attempts, ":", invitationCode);
      
      // Check if this code already exists
      const existingInvitation = await getDoc(doc(db, "invitations", invitationCode));
      if (!existingInvitation.exists()) {
        console.log("Invitation code is unique, proceeding");
        break;
      }
      
      console.log("Invitation code already exists, trying again");
      
      if (attempts >= maxAttempts) {
        throw new Error("Could not generate unique invitation code");
      }
    } while (attempts < maxAttempts);
    
    console.log("Final invitation code:", invitationCode);
    
    // Create invitation document with the code as the document ID
    const invitationRef = doc(db, "invitations", invitationCode);
    console.log("About to write invitation to Firestore with doc ref:", invitationRef.path);
    
    const invitationData = {
      tempUserId,
      createdAt: serverTimestamp()
    };
    
    console.log("Invitation data to write:", invitationData);
    
    await setDoc(invitationRef, invitationData);
    
    const inviteUrl = `${window.location.origin}/invite?code=${invitationCode}`;
    console.log("Successfully created invitation, URL:", inviteUrl);
    return inviteUrl;
  } catch (error) {
    console.error("Error in createInvitation function:", error);
    console.error("Error details:", {
      code: error.code,
      message: error.message,
      stack: error.stack
    });
    throw error;
  }
};
